import { render, staticRenderFns } from "./DoctorList.vue?vue&type=template&id=1e03077c&"
import script from "./DoctorList.vue?vue&type=script&lang=js&"
export * from "./DoctorList.vue?vue&type=script&lang=js&"
import style0 from "./DoctorList.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports